import { push as updatePath } from 'react-router-redux';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { put, call, takeEvery } from 'redux-saga/effects';
import { promotionByAlias } from 'redux/saga/entities/bound';
import { getMsa } from 'containers/LocationModal/location.saga';
import Base64Deriver from 'derivers/Base64';

const CHECKOUT_OFFER = 'OFFER_CHECKOUT/CHECKOUT_OFFER';

export const checkoutOffer = promotionAlias => ({ type: CHECKOUT_OFFER, promotionAlias });

export function* doCheckoutOffer(client, { promotionAlias }) {
  try {
    const { id: msaId } = yield call(getMsa, client);
    const { offers } = yield call(fetchEntityIfNeeded, promotionByAlias, [client, promotionAlias, msaId]);
    const { id: msaOfferId } = offers.reduce(
      (bestOffer, currentOffer) => (currentOffer.offer.priority < bestOffer.offer.priority ? currentOffer : bestOffer),
      offers[0]
    );

    yield put(updatePath(`/signup/offer/${Base64Deriver.encode(msaOfferId)}`));
  } catch (error) {
    /* noop */
  }
}

export function* watchOfferCheckout(client) {
  yield takeEvery(CHECKOUT_OFFER, doCheckoutOffer, client);
}
